/**
 * Loads the firmware catalog manifest and individual firmware ZIPs
 * from the static/firmware/ directory.
 *
 * The manifest schema is defined in static/firmware/manifest.json.
 */

// Use root-relative URLs so the fetches work regardless of the page path
// (e.g., http://localhost:8601/, /editor/, /projects/123/editor).
const MANIFEST_URL = '/static/firmware/manifest.json';
const FIRMWARE_BASE = '/static/firmware/';

/**
 * Fetch and parse the firmware manifest.
 * @returns {Promise<{version: number, firmwares: Array}>}
 */
const loadManifest = function () {
    return fetch(MANIFEST_URL).then(res => {
        if (!res.ok) {
            throw new Error(`Failed to load firmware manifest: ${res.status}`);
        }
        return res.json();
    });
};

/**
 * Fetch a firmware ZIP as ArrayBuffer.
 * @param {string} filename - Relative filename from manifest (e.g., "servo.zip").
 * @returns {Promise<ArrayBuffer>}
 */
const loadFirmwareZip = function (filename) {
    return fetch(`${FIRMWARE_BASE}${filename}`).then(res => {
        if (!res.ok) {
            throw new Error(`Failed to load firmware ${filename}: ${res.status}`);
        }
        return res.arrayBuffer();
    });
};

export {loadManifest, loadFirmwareZip};
